import React, { Component } from 'react';

import styles from './styles.m.scss';

import Footer from '../../../../../components/Accordion/Footer';
import FinalSummaryTable from './Components/FinalSummaryTable';
import { handleErrorBase, handleSuccessBase } from '../../../../../util/forms';
import { apiSubmitRegistration } from '../../../../../api/registration';

class FinalSummary extends Component {
  render() {
    const { setStep, step, registration, user, updateRegistration } = this.props;

    return (
      <div>
        <h2 className={styles.stepHeader}>Please review your information</h2>
        <FinalSummaryTable user={user} registration={registration} />
        <Footer
          step={step}
          setStep={setStep}
          finishBtn={() => (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() =>
                apiSubmitRegistration(registration.id)
                  .then(({ data }) => updateRegistration(data))
                  .then(() => handleSuccessBase())
                  .catch(() => handleErrorBase())
              }
            >
              Submit
            </button>
          )}
        />
      </div>
    );
  }
}

export default FinalSummary;
